import dayjs from 'dayjs';
import { ColumnDef } from '@benzinga/table';
import { AmountBags } from './AmountBags';
import { formatTransaction } from './formatTransaction';
import { SecurityNameCell, SecurityTickerLink, TxnSide } from './TableCells';

export const MemberLargestColumnsDef = [
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => {
      const { company_name, logo, ticker } = data;
      return <SecurityNameCell logo={logo} name={company_name} ticker={ticker} />;
    },
    field: 'company_name',
    headerName: 'Name',
    sortEnabled: true,
    width: 220,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => <SecurityTickerLink ticker={data.ticker} />,
    field: 'ticker',
    headerName: 'Symbol',
    sortEnabled: true,
    width: 100,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => <AmountBags amount={data.trade_amount} transactionType={data.transaction_type} />,
    field: 'trade_amount',
    headerName: 'Price',
    sortEnabled: true,
    width: 140,
  },
  {
    cellClass: 'security-cell type',
    field: 'security_type',
    headerName: 'Type',
    sortEnabled: true,
    valueFormatter: ({ value }) => {
      return value.toLowerCase();
    },
    width: 100,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => (
      <TxnSide type={data.transaction_type}>{formatTransaction(data.transaction_type)}</TxnSide>
    ),
    field: 'transaction_type',
    headerName: 'Transaction',
    sortEnabled: true,
    width: 130,
  },
  {
    cellClass: 'security-cell',
    field: 'transaction_date',
    headerName: 'Trade Date',
    sortEnabled: true,
    valueFormatter: ({ value }) => {
      return dayjs(value).format('MMM DD, YYYY');
    },
    width: 100,
  },
] as ColumnDef<any>[];
